import { useProjectFilter } from '@/features/projects/hooks/projectHooks';
import { UploadFilesDialog } from '@/features/uploads/components/UploadFilesDialog';
import { Tooltip } from '@/ui';
import { Button } from '@/ui/primitives';
import { UploadFileIcon } from '@/ui/primitives/icons';
import { useCoverageUploadFlow } from '../hooks/useCoverageUploadFlow';
import type { ReactElement } from 'react';

export const CoverageUploadAction = (): ReactElement => {
  const { selectedProjectId } = useProjectFilter();
  const uploadFlow = useCoverageUploadFlow();
  const isDisabled = uploadFlow.projectOptions.length === 0 && selectedProjectId === null;

  return (
    <>
      <Tooltip
        title={isDisabled ? 'Create or select a project before uploading coverage files.' : ''}
        disableHoverListener={!isDisabled}
      >
        <span>
          <Button
            variant="primary"
            startIcon={<UploadFileIcon />}
            onClick={uploadFlow.openUploadDialog}
            disabled={isDisabled}
            fullWidthOnMobile={false}
          >
            Upload Coverage
          </Button>
        </span>
      </Tooltip>
      <UploadFilesDialog
        open={uploadFlow.open}
        title="Upload Coverage Files"
        saveLabel="Upload Coverage"
        saving={uploadFlow.isUploading}
        disableSave={uploadFlow.disableUpload}
        errorMessage={uploadFlow.uploadError}
        projectOptions={uploadFlow.projectOptions}
        uploadProjectId={uploadFlow.uploadProjectId}
        setUploadProjectId={uploadFlow.setUploadProjectId}
        uploadFiles={uploadFlow.uploadFiles}
        setUploadFiles={uploadFlow.setUploadFiles}
        selectedFiles={uploadFlow.selectedFiles}
        setSelectedFiles={uploadFlow.setSelectedFiles}
        onClose={uploadFlow.closeUploadDialog}
        onSave={uploadFlow.handleUpload}
      />
    </>
  );
};
